module.exports = __webpack_public_path__ + "static/media/Свидетельство СРО (Народная опора).4aa98537.jpg";